import styled from "@emotion/styled";
import theme from "../../styles/theme";
import { Link as LoftLink } from "@xometry/xometry_loft";

type ImageProps = {
  image: string;
};

export const PostHighlightBase = styled.div`
  display: flex;
  justify-content: center;
`;

export const PostHighlightBackground = styled.div`
  max-width: ${theme.maxWidth};
`;

export const Content = styled.div`
  background-color: #fafcff;
  display: flex;
  flex-direction: column;
  padding: 24px;

  ${theme.largerThan.md} {
    flex-direction: row;
    padding: 48px;
  }
`;

export const Image = styled.div<ImageProps>`
  border-radius: 5px;
  flex: 1 0 50%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-image: url("${(props) => props.image}");
  min-height: 200px;

  ${theme.largerThan.md} {
    height: 492px;
  }
`;

export const SmallImage = styled.img`
  max-height: 80px;
  object-fit: scale-down;
  align-self: flex-start;
  margin-bottom: 16px;
`;

export const Text = styled.div`
  display: flex;
  flex-direction: column;
  margin: 16px 0 0 0;
  flex: 1 1 auto;

  ${theme.largerThan.md} {
    margin: 16px 0 16px 48px;
  }
`;

export const Title = styled.h3``;

export const Subtitle = styled.div`
  color: ${theme.colors.darkBlues[90]};
  font-size: 16px;
  line-height: 24px;
  flex: 1 0 auto;
  margin-bottom: 16px;
`;

export const Link = styled(LoftLink)`
  flex: 0 1 auto;
  font-size: 16px;
  line-height: 24px;
`;
